var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthenticationDialog',[_c('div',{staticClass:"text-center pb-10"},[_vm._v(" Login with Okta "),_c('br'),(_vm.loading)?_c('v-progress-circular',{staticClass:"mt-10",attrs:{"indeterminate":"","size":"64"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }